const state = {
  form: {},
  error: [],
  alert: [],
  support_access: [],
  plan_proposal: [],
};

const getters = {
  get: state => state,
  form: state => state.form,
  hasError: state => state.error.length > 0,
  error: state => state.error,
  hasAlert: state => !_.isEmpty(state.alert),
  alert: state => state.alert,
  support_access: state => state.support_access,
  plan_proposal: state => state.plan_proposal,
  hasPlanProposal: state => !_.isEmpty(state.plan_proposal),
  hasSupportAccess: state => !_.isEmpty(state.support_access),
};

const mutations = {
  SET(state, data) {
    const { _error, _alert, _form } = data

    state.error = _.isArray(_error) ? _error : []
    state.alert = _.isPlainObject(_alert) ? _alert : []
    state.form = _.isPlainObject(_form) ? _form : {}
    state.support_access = (typeof _support_access != 'undefined') && _.isPlainObject(_support_access) ? _support_access : {}
    state.plan_proposal = (typeof _plan_proposal != 'undefined') && _.isPlainObject(_plan_proposal) ? _plan_proposal : {}
  },
};

const actions = {
  set({ commit }, data) {
    commit('SET', data)
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
